import React, { useEffect, useMemo } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as CheckIcon } from '../images/check-icon.svg'
import GooglePlay from '../images/google-play.png'
import AppStore from '../images/app-store.png'
import { ReactComponent as CryFace } from '../images/cry-icon.svg'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEnachStatusMutation } from '../lib/services/enachApi';
import { useDispatch, useSelector } from 'react-redux';
import { setError } from '../lib/features/kycSlice';
import { openModal, setEnachStatusDetails } from '../lib/features/enachSlice';
import PageHeader from '../components/PageHeader';
import { formatCurrency } from '../lib/middleware/currencyFormatter';
import { useTapClickMutation } from '../lib/middleware/TapClickApi';
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";

function Rejected() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [enachStatus] = useEnachStatusMutation()
    const { enachStatusDetails } = useSelector((state) => state.enach);
    const location = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
    const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams])
    const secret = useMemo(() => queryParams.get('secret'), [queryParams])
    const [tapClick] = useTapClickMutation()

    
    return (
        <div className='external-wrapper'>
            <div className='page-content enach-success-page'>
                <PageHeader />
                <div className="approval-content">                  
                    
                    

                     <div className="approval-card failed">
                        <div className="icon-check">
                            <CryFace />
                        </div>
                        <h2>Sorry!</h2>
                        <p>We don't have any offers for you currently</p>
                    </div>


                    <div className="unlock-info">
                        {/*enachStatusDetails && (enachStatusDetails.loan_status === 'Disbursed' || enachStatusDetails.loan_status === 'Approved') ? <p className='bold-text'>Explore more services on Stashfin app!</p> : <p className='bold-text'>Explore more services on Stashfin app!</p>*/}
                        <p className='bold-text'>Explore more services on Stashfin app!</p>
                        <div className="logo-links">
                            <StarfinLogo className='logo' />
                            <div className="download-links">
                                <Link to="https://stash.page.link/68s3" target="_blank"><img src={AppStore} alt='App Store' /></Link>
                                <Link to="https://stash.page.link/68s3" target="_blank"><img src={GooglePlay} alt='Play Store' /></Link>
                            </div>
                        </div>
                    </div>
                    <div className='bottom-footer p-0'>
                        {/*<Link to="#" className='partner-link'>Back to partner's page</Link>*/}
                        <button className="btn btn-primary" onClick={() => {
                            //navigate('/complete-your-kyc')
                            window.open('https://stash.page.link/68s3', "_blank")
                        }}>Download App</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Rejected;
